<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15.168861262512207,4.438888008651734L5.835541262512207,15.105528008651733C5.593088262512207,15.382628008651734,5.1719132625122075,15.410728008651734,4.894822262512207,15.168328008651734C4.617731162512207,14.925828008651733,4.589652862512207,14.504628008651734,4.832107262512207,14.227528008651733L14.165441262512207,3.5608790086517335C14.407901262512206,3.2837876086517332,14.829061262512207,3.255709208651733,15.106161262512208,3.4981640086517336C15.383261262512207,3.7406190086517332,15.411361262512207,4.161794008651733,15.168861262512207,4.438888008651734ZM15.179261262512208,11.093428008651735L11.845981262512208,15.093428008651733C11.610271262512207,15.376228008651733,11.189891262512207,15.414528008651734,10.907041262512207,15.178828008651733C10.624191262512207,14.943028008651734,10.585971262512206,14.522728008651733,10.821681262512207,14.239828008651733L14.155021262512207,10.239848008651734C14.390731262512206,9.956998008651734,14.811061262512206,9.918778008651733,15.093961262512208,10.154488008651732C15.376761262512208,10.390198008651733,15.415061262512207,10.810578008651733,15.179261262512208,11.093428008651735Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'ResizeTextarea',
} as DefineComponent
</script>
